export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-04_EN.6764f9e2.png";